import type { LucideIcon } from "lucide-react";

export const VIEWPORT_TOOLSET_IDS = {
  scale: "scale",
  measurement: "measurement",
  tags: "tags",
} as const;

export type ViewportToolsetId =
  (typeof VIEWPORT_TOOLSET_IDS)[keyof typeof VIEWPORT_TOOLSET_IDS];

export const VIEWPORT_TOOLSET_PLACEMENTS = {
  leftRail: "left-rail",
  topToolbar: "top-toolbar",
  menu: "menu",
} as const;

export type ViewportToolsetPlacement =
  (typeof VIEWPORT_TOOLSET_PLACEMENTS)[keyof typeof VIEWPORT_TOOLSET_PLACEMENTS];

export const VIEWPORT_TOOL_KINDS = {
  draw: "draw",
  workflow: "workflow",
  toggle: "toggle",
} as const;

export type ViewportToolKind =
  (typeof VIEWPORT_TOOL_KINDS)[keyof typeof VIEWPORT_TOOL_KINDS];

export interface ViewportToolDefinition<
  TToolId extends string = string,
  TToolsetId extends string = string,
> {
  id: TToolId;
  label: string;
  toolsetId: TToolsetId;
  kind: ViewportToolKind;
  icon?: LucideIcon;
}

export interface ViewportToolsetDefinition<
  TToolsetId extends string = string,
  TToolId extends string = string,
> {
  id: TToolsetId;
  label: string;
  placement: ViewportToolsetPlacement;
  tools: TToolId[];
}
